import { render, staticRenderFns } from "./CreateAccesspoint.vue?vue&type=template&id=c7331d72&scoped=true"
import script from "./CreateAccesspoint.vue?vue&type=script&lang=js"
export * from "./CreateAccesspoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7331d72",
  null
  
)

export default component.exports